import { AddressesPage } from "./AddressesPage";

export default AddressesPage;